import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import CustomSelect from './CustomSelect';
import CustomAutocomplete from './CustomAutocomplete';
import srvAutocomplete from '../../services/srv-autocomplete';
import countries from '../../data/countries';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';


class StepPlace extends Component {
    constructor(props) {
        super(props);
        this.state = { event: this.props.event, disablenextbtn: true };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputBlur = this.handleInputBlur.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.validatorListener = this.validatorListener.bind(this);
        this.handlePlaceUpdate = this.handlePlaceUpdate.bind(this);
    }

    componentWillMount() {
    
    }

    handleInputChange(event) {
        let eventState = Object.assign({}, this.state.event);
        let eventStateLocation = Object.assign({}, this.state.event.location, { [event.target.name]: event.target.value });
        eventState.location = eventStateLocation;
        this.setState({ event: eventState });
        return this.props.returnfnc(eventState);
    }

    handleInputBlur(event) {
        this.refs[event.target.name].validate(event.target.value);
    }

    validatorListener(result) {
        if (result)
            return this.props.returnfnc(this.state.event);
    }

    handlePlaceUpdate(fieldname, fieldvalue) {
        let eventState = Object.assign({}, this.state.event);
        let eventStateLocation = Object.assign({}, this.state.event.location, { [fieldname]: fieldvalue });
        eventState.location = eventStateLocation;
        this.setState({ event: eventState });
        console.log("Event updated: ", eventState);
    }

    handleSubmit() { }

    render() {
        const { event } = this.state;
        return (
            <ValidatorForm instantValidate={false} onSubmit={this.handleSubmit}>
                <div className="row">
                    <div className="col-sm-6">
                        <CustomSelect inputlist={countries} defaultvalue={"Italia"} fieldname={"state"} returnfunc={this.handlePlaceUpdate} ></CustomSelect>
                    </div>
                    <div className="col-sm-6">
                        <CustomAutocomplete autocompletfunc={srvAutocomplete.getCitiesSuggestions} fieldname={"city"} returnfunc={this.handlePlaceUpdate} ></CustomAutocomplete>
                    </div>
                    <div className="col-12 text-center">
                        <TextValidator
                            ref="address"
                            name="address"
                            label="Indirizzo"
                            InputLabelProps={{ shrink: true }}
                            value={event.address}
                            onBlur={this.handleInputBlur}
                            onChange={this.handleInputChange}
                            validators={['required']}
                            errorMessages={['Inserire l\'indirizzo dove si svolgerà l\'evento']}
                            validatorListener={this.validatorListener}
                        />
                    </div>
                    <div className="col-12 text-center">
                        <TextField
                            id="place"
                            name="place"
                            label="place"
                            value={event.place}
                            onChange={this.handleInputChange}
                            margin="normal"
                        />
                    </div>
                </div>
            </ValidatorForm>
        );
    }
}

StepPlace.propTypes = {
    event: PropTypes.object.isRequired,
    returnfnc: PropTypes.func.isRequired
};

export default StepPlace;


// WEBPACK FOOTER //
// ./src/components/eventstepper/StepPlace.js